import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogService } from '@progress/kendo-angular-dialog';
import { CalamityService } from 'app/calamity/calamity.service';
import { CalamityActionNoteModel } from 'app/calamity/models/calamity-action-note.model';
import { IntakeService } from 'app/intake/intake-services/intake.service';
import { NoteTypeService } from 'app/intake/note/note-type.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CalamityNoteDetailsComponent } from '../calamity-note-details/calamity-note-details.component';
import { CalamityNoteService } from '../calamity-note.service';

@Component({
  selector: 'app-calamity-notes-list',
  templateUrl: './calamity-notes-list.component.html',
  styleUrls: ['./calamity-notes-list.component.scss']
})
export class CalamityNotesListComponent implements OnInit {
  errorPopup: any = null;
  public noteList: any[] = [];
  public initiaNoteList = [];
  private _subject$: Subject<boolean> = new Subject();
  public calamityId : string ;
  public noteTypesNotFiltered: any[] = [];
  public noteTypeValue = [];
  public operation_costControlTypeFields: any[] = [];
  public selectedNoteType: any;
  public dateFromFilter: Date;
  public dateToFilter: Date;
  @Output() notesListPerAction = new EventEmitter();
  @Input() addAction: boolean;
  @Input() calamityActionNotes: CalamityActionNoteModel[];
  @Input() previousNotes: any[];
  @Input() actionId: string;

  constructor(private dialogService: DialogService,
    private calamityNoteService: CalamityNoteService,
    private calamityService: CalamityService,
    private cd: ChangeDetectorRef,
    private datepipe: DatePipe,
    private noteTypeService: NoteTypeService,
    private intakeService: IntakeService) { }

  ngOnInit() {
    this.getCalamityId();
    this.getNoteTypes();
  }

  openNoteDetails(){
    const dialogRef = this.dialogService.open({
      content: CalamityNoteDetailsComponent,
      minWidth: "700px",
      width: "700px",
    });
    dialogRef.content.instance.addAction = this.addAction;
    dialogRef.content.instance.noteList = this.noteList;
    dialogRef.result.subscribe((results: any) => {
      if (results.clnCalamityId) {
        results.clnCreatedDate = new Date();
        this.noteList = this.noteTypesNotFiltered;
        this.buildInNoteTypeList(results);
        this.noteTypesNotFiltered = this.noteList;
        this.initiaNoteList.push(results);
        this.notesListPerAction.emit(this.noteTypesNotFiltered);
      }
    });
  }

  getNoteTypes() {
    this.noteTypeService
      .getAll(true)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        data.forEach((element) => {
          this.noteTypeValue.push(element);
        });
        if (this.actionId == undefined && !this.addAction) this.getNotes();
        else if ((this.actionId == undefined && this.addAction) || (this.actionId != undefined && this.previousNotes.length != 0)) {
          this.noteTypesNotFiltered = this.previousNotes;
          this.noteList = this.previousNotes;
        } else {
          this.calamityActionNotes.forEach((el) => {
            try {
              let parseObject = JSON.parse(el.canCalamityNote.clnFreeText);
              if (parseObject) {
                if (
                  parseObject.isDependent != undefined &&
                  parseObject.isDependent == true
                )
                  this.buildInNoteTypeList(el.canCalamityNote);
                this.noteTypesNotFiltered = this.noteList;
              }
            } catch (e) {
              return false;
            }
          });
        }
      });
  }

  getCalamityId(){
    this.calamityService.calId$.pipe(takeUntil(this._subject$))
    .subscribe(res=> {
       this.calamityId=res;
    });
  }

  getNotes() {
    this.noteList = [];
    this.calamityNoteService
      .getNotesByCalamityId(this.calamityId)
      .pipe(takeUntil(this._subject$))
      .subscribe((dataAll: any) => {
        this.initiaNoteList = dataAll;
        dataAll.forEach((element) => {
          try {
            let parseObject = JSON.parse(element.clnFreeText);
            if (parseObject) {
              this.buildInNoteTypeList(element);
              this.noteTypesNotFiltered = this.noteList;
            }
          } catch (e) {
            return false;
          }
        });
      });
  }
  getDate(date) {
    return this.getLocaleDate(date);
  }
  getLocaleDate(date: Date) {
    if (date != null && (this.isIsoDate(date.toString()) || date.toString().indexOf('GMT') == -1)) {
      return this.intakeService.getLocalDate(date);
    }
    return date;
  }
  isIsoDate(dateStringToCompare) {
    return new Date(dateStringToCompare).toISOString() === dateStringToCompare;
  }

  buildInNoteTypeList(element) {
    let noteType = this.noteTypeValue.find(
      (noteType) => noteType.notId == element.clnNoteTypeId
    );
    this.parseJsonFreeText(element.clnFreeText, "Operations");
      let operationNoteType = {
        id: element.clnId,
        title: "Operations",
        fields: this.operation_costControlTypeFields,
        createdBy: element.clnCreatedBy,
        createdDateToFilter: this.getDate(element.clnCreatedDate),
        createdDate: this.datepipe.transform(
          this.getDate(element.clnCreatedDate),
          "dd-MM-yyyy HH:mm"
        ),
      };
      this.noteList.push(operationNoteType);
      this.cd.detectChanges();
  }

  parseJsonFreeText(jsonFreeText, noteType) {
    try {
      var parseObject = JSON.parse(jsonFreeText);
      if (parseObject) {
        this.operation_costControlTypeFields = [];
          if (parseObject.contactWith) {
            this.operation_costControlTypeFields.push({
              title: "Contact With",
              value: parseObject.contactWith,
            });
          }
          if (parseObject.medicalInformation) {
            this.operation_costControlTypeFields.push({
              title: "Medical Information",
              value: parseObject.medicalInformation,
            });
          }
          if (parseObject.conversationNote) {
            this.operation_costControlTypeFields.push({
              title: "Conversation Note",
              value: parseObject.conversationNote,
            });
          }
          if (parseObject.agreements) {
            this.operation_costControlTypeFields.push({
              title: "Agreements",
              value: parseObject.agreements,
            });
          }
          if (parseObject.guarantees) {
            this.operation_costControlTypeFields.push({
              title: "Guarantees",
              value: parseObject.guarantees,
            });
          }
        }

    } catch (e) {
      return false;
    }
  }

  filterNotes() {
    let notesToreturn = this.noteTypesNotFiltered;
    if (this.selectedNoteType)
      notesToreturn = notesToreturn.filter(
        (element) => element.title == this.selectedNoteType.notLongName
      );
    if (this.dateFromFilter)
      notesToreturn = notesToreturn.filter(
        (element) =>
          new Date(element.createdDateToFilter) >= this.dateFromFilter
      );
    if (this.dateToFilter)
      notesToreturn = notesToreturn.filter(
        (element) => new Date(element.createdDateToFilter) <= this.dateToFilter
      );
    this.noteList = notesToreturn;
  }

  update(){
    this.calamityNoteService
      .save(this.initiaNoteList)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {

      });
  }
}